export const coordinatesToString = (coordinates: { latitude: number; longitude: number }): string => {
  const latitude = coordinates.latitude.toFixed(6)
  const longitude = coordinates.longitude.toFixed(6)
  return `${latitude}º N, ${longitude}º W`
}

export const isValidLatAndLong = (lat: number | string, lon: number | string): boolean => {
  const num1 = '' + lat
  const num2 = '' + lon
  if (parseFloat(num1) <= 90 && parseFloat(num1) >= -90 && parseFloat(num2) <= 180 && parseFloat(num2) >= -180) {
    return true
  } else {
    return false
  }
}

export const calculateBearing = (start: google.maps.LatLngLiteral, end: google.maps.LatLngLiteral): number => {
  const startLat = (start.lat * Math.PI) / 180
  const startLng = (start.lng * Math.PI) / 180
  const endLat = (end.lat * Math.PI) / 180
  const endLng = (end.lng * Math.PI) / 180

  const dLng = endLng - startLng

  const y = Math.sin(dLng) * Math.cos(endLat)
  const x = Math.cos(startLat) * Math.sin(endLat) - Math.sin(startLat) * Math.cos(endLat) * Math.cos(dLng)

  const bearing = Math.atan2(y, x)
  return ((bearing * 180) / Math.PI + 360) % 360
}
